import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import { FaExpeditedssl } from "react-icons/fa";
import { FormField } from "./FormField";
import { buttonText, labelText } from "../../lib/constants";
export const UserFormFields = ({
  values,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  errors,
  touched,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Check
        type="switch"
        id="accepted_terms"
        name="accepted_terms"
        label={
          <span>
            {labelText.conduct_code_description}{" "}
            <a
              href="https://ibft.com.br/latam/codigo-de-conducta/"
              rel="noreferrer"
              target="_blank"
            >
              {labelText.conduct_code_link}
            </a>
            .
          </span>
        }
        onBlur={handleBlur}
        onChange={handleChange}
        checked={values.accepted_terms}
      />
      <br />

      <Form.Check
        type="switch"
        id="qualified_to_assist"
        name="qualified_to_assist"
        label={labelText.mark_as_available}
        onBlur={handleBlur}
        onChange={handleChange}
        checked={values.qualified_to_assist}
      />

      <br />

      <p>{labelText.availability}</p>

      {errors.validation_errors && Array.isArray(errors.validation_errors) && (
        <Alert variant="danger" className="mt-3">
          <ul className="mb-0">
            {errors.validation_errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      <FormField
        type="textarea"
        fieldAttributes={{ as: "textarea" }}
        name="availability"
        error={errors.availability}
        touched={touched.availability}
        handleBlur={handleBlur}
        handleChange={handleChange}
        value={values.availability}
      />
      <div className="d-grid gap-2">
        <Button
          disabled={isSubmitting}
          variant="success"
          type="submit"
          className="mt-3"
        >
          {isSubmitting && (
            <div>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">{buttonText.processing}</span>
              </Spinner>
            </div>
          )}

          {!isSubmitting && (
            <div>
              <FaExpeditedssl /> {buttonText.save_preferences}
            </div>
          )}
        </Button>
      </div>
    </Form>
  );
};

UserFormFields.propTypes = {};
